import api from "../../api.js";

export async function listServices() {
  const res = await api.get("/api/clinic/services");
  return res.data?.data || [];
}

export async function getService(id) {
  const res = await api.get(`/api/clinic/services/${encodeURIComponent(id)}`);
  return res.data?.data || null;
}

export async function createService(payload) {
  const res = await api.post("/api/clinic/services", payload);
  return res.data;
}

export async function updateService(id, payload) {
  const res = await api.put(`/api/clinic/services/${encodeURIComponent(id)}`, payload);
  return res.data;
}

export async function deleteService(id) {
  const res = await api.delete(`/api/clinic/services/${encodeURIComponent(id)}`);
  return res.data;
}
